import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Box, Paper, Typography, Grid, Avatar, Chip, Divider,
  Card, CardContent
} from '@mui/material';

import { message } from 'antd';
import Swal from 'sweetalert2';

// ICONOS MUI
import CakeIcon from '@mui/icons-material/Cake';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaidIcon from '@mui/icons-material/Paid';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

function ViewBirthday() {
  const [birthday, setBirthday] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const { XVID } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const fetchBirthdayData = async () => {
    const accessToken = localStorage.getItem('token');
    try {
      const response = await fetch(`https://dprincess-training.servehttp.com/xv/birthdays/${XVID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        },
      });
      if (!response.ok) messageApi.open({
        type: 'error',
        content: 'No se pudo cargar la información del cumpleaños',
        duration: 2,
      });
      const data = await response.json();
      setBirthday(data);
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: 'Error al cargar los datos del cumpleaños',
        duration: 2,
      });
    }
  };

  // Calcula días restantes para el cumpleaños
  const calculateDaysRemaining = (birthdayDate) => {
    if (!birthdayDate) return null;

    const today = new Date();
    const birthDate = new Date(birthdayDate);

    // Ajusta al año actual
    birthDate.setFullYear(today.getFullYear());

    // Si ya pasó, calcula para el próximo año
    if (today > birthDate) {
      birthDate.setFullYear(today.getFullYear() + 1);
    }

    const diffTime = Math.abs(birthDate - today);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  const daysRemaining = calculateDaysRemaining(birthday?.birthday);

  // Formateado de moneda
  const formatCurrency = (value) => {
    if (value == null) return 'No registrado';

    const numValue = parseFloat(String(value).replace(/,/g, ''));
    if (isNaN(numValue)) return 'No registrado';

    return numValue.toLocaleString('es-DO', {
      style: 'currency',
      currency: 'DOP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  useEffect(() => {
    fetchBirthdayData();
  }, []);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {contextHolder}
      { birthday
          ? (
            <>
              {/* Encabezado con información principal */}
              <Paper
                elevation={3}
                sx={{
                  borderRadius: '24px',
                  overflow: 'hidden',
                  mb: 4,
                  background: 'linear-gradient(135deg, #f8fafc 0%, #f3e8ff 100%)',
                  border: '1px solid rgba(124, 58, 237, 0.1)',
                }}
              >
                {/* Banner superior */}
                <Box
                  sx={{
                    p: 3,
                    background: 'linear-gradient(90deg, #f759ab 30%, #9333ea 100%)',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -15,
                      right: -15,
                      width: 80,
                      height: 80,
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 0.15)',
                    }}
                  />

                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Avatar
                        sx={{
                          bgcolor: 'white',
                          width: 64,
                          height: 64,
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }}
                      >
                        <CakeIcon sx={{ fontSize: 36, color: '#f759ab' }} />
                      </Avatar>
                    </Grid>
                    <Grid item xs>
                      <Typography variant="h4" fontWeight={700} sx={{ mb: 0.5 }}>
                        {birthday.XVName}
                      </Typography>

                      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <CalendarMonthIcon sx={{ fontSize: 20, mr: 0.5 }} />
                          <Typography variant="subtitle1">
                            {new Date(birthday.birthday).toLocaleDateString()}
                          </Typography>
                        </Box>

                        {daysRemaining !== null && (
                          <Chip
                            label={`${daysRemaining} ${daysRemaining === 1 ? 'día' : 'días'} restantes`}
                            size="small"
                            color={daysRemaining <= 7 ? "error" : daysRemaining <= 30 ? "warning" : "default"}
                            sx={{ fontWeight: 500 }}
                          />
                        )}

                        <Chip
                          icon={<AssignmentTurnedInIcon />}
                          label={birthday.status || "No definido"}
                          size="small"
                          color={birthday.status === "pendiente" ? "warning" : "success"}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>

                {/* Datos del evento */}
                <Box sx={{ p: 3 }}>
                  <Typography variant="h6" fontWeight={600} color="#5b21b6" gutterBottom>
                    Detalles del Evento
                  </Typography>

                  <Grid container spacing={3}>
                    {/* Columna izquierda */}
                    <Grid item xs={12} md={6}>
                      <InfoItem icon={<EventIcon color="primary" />} label="Evento" value={birthday.eventTitle} />
                      <InfoItem icon={<LocationOnIcon sx={{ color: '#22c55e' }} />} label="Lugar" value={birthday.eventLocation} />
                      <InfoItem
                        icon={<AccessTimeIcon sx={{ color: '#f759ab' }} />}
                        label="Fecha y hora de inicio"
                        value={birthday.eventDateStart ? new Date(birthday.eventDateStart).toLocaleString() : 'No registrado'}
                      />
                      <InfoItem
                        icon={<AccessTimeIcon sx={{ color: '#f759ab' }} />}
                        label="Fecha y hora de finalización"
                        value={birthday.eventDateEnd ? new Date(birthday.eventDateEnd).toLocaleString() : 'No registrado'}
                      />
                    </Grid>

                    {/* Columna derecha */}
                    <Grid item xs={12} md={6}>
                      <InfoItem
                        icon={<ConfirmationNumberIcon />}
                        label="Confirmación"
                        value={birthday.confirmation ? "Confirmado" : "Pendiente de confirmación"}
                        valueProps={{
                          sx: {
                            color: birthday.confirmation ? '#22c55e' : '#d97706',
                            fontWeight: 600
                          }
                        }}
                      />
                      <InfoItem
                        icon={<PaidIcon sx={{ color: '#f759ab' }} />}
                        label="Paquete"
                        value={birthday.comboName}
                      />
                      <InfoItem
                        icon={<AssignmentTurnedInIcon />}
                        label="Estado del evento"
                        value={birthday.status || 'No registrado'}
                        valueProps={{
                          sx: {
                            color: birthday.status === 'pendiente' ? '#d97706' : '#22c55e',
                            fontWeight: 600
                          }
                        }}
                      />
                      <InfoItem
                        icon={<PaidIcon />}
                        label="Estado del pago"
                        value={birthday.paymentStatus || 'No registrado'}
                        valueProps={{
                          sx: {
                            color: birthday.paymentStatus === 'pendiente' ? '#d97706' : '#22c55e',
                            fontWeight: 600
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Paper>

              {/* Tarjetas de información adicional */}
              <Grid container spacing={3}>
                {/* Información del festejado */}
                <Grid item xs={12} md={6}>
                  <InfoCard
                    title="Información del Festejado"
                    icon={<CakeIcon fontSize="large" sx={{ color: '#f759ab' }} />}
                  >
                    <InfoItem icon={<PersonIcon color="primary" />} label="Nombre" value={birthday.XVName} />
                    <InfoItem icon={<SmartphoneIcon sx={{ color: '#f59e42' }} />} label="Celular" value={birthday.XVCellphoneNumber} />
                    <InfoItem icon={<EmailIcon sx={{ color: '#7c3aed' }} />} label="Correo" value={birthday.XVEmail} />
                  </InfoCard>
                </Grid>

                {/* Información del cliente/responsable */}
                <Grid item xs={12} md={6}>
                  <InfoCard
                    title="Información del Cliente"
                    icon={<PersonIcon fontSize="large" sx={{ color: '#5b21b6' }} />}
                  >
                    <InfoItem icon={<PersonIcon color="primary" />} label="Nombre" value={birthday.clientName} />
                    <InfoItem icon={<PhoneIcon sx={{ color: '#f59e42' }} />} label="Teléfono" value={birthday.phoneNumber} />
                    <InfoItem icon={<SmartphoneIcon sx={{ color: '#f59e42' }} />} label="Celular" value={birthday.cellphoneNumber} />
                    <InfoItem icon={<EmailIcon sx={{ color: '#7c3aed' }} />} label="Correo" value={birthday.clientEmail} />
                    <InfoItem icon={<HomeIcon sx={{ color: '#22c55e' }} />} label="Dirección" value={birthday.address} />
                  </InfoCard>
                </Grid>

                {/* Información financiera */}
                <Grid item xs={12} onClick={() => navigate(`/billing/invoice/${birthday.invoiceID}`)} >
                  <InfoCard
                    title="Información Financiera"
                    icon={<PaidIcon fontSize="large" sx={{ color: '#22c55e' }} />}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <InfoItem
                          icon={<PaidIcon sx={{ color: '#f759ab' }} />}
                          label="Precio del paquete"
                          value={formatCurrency(birthday.comboPrice)}
                        />
                        <InfoItem
                          icon={<PaidIcon sx={{ color: '#f759ab' }} />}
                          label="Total servicios extras"
                          value={formatCurrency(birthday.servicesTotal)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InfoItem
                          icon={<PaidIcon sx={{ color: '#22c55e' }} />}
                          label="Depósito realizado"
                          value={formatCurrency(birthday.paymentAmount)}
                        />
                        { birthday.totalAmount && (
                          <InfoItem
                            icon={<PaidIcon sx={{ color: '#d97706' }} />}
                            label="Saldo total"
                            value={formatCurrency(parseFloat(birthday.totalAmount))}
                            valueProps={{
                              sx: {
                                color: '#d97706',
                                fontWeight: 600
                              }
                            }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </InfoCard>
                </Grid>
              </Grid>
            </>)
          : (
            <Container maxWidth="md" sx={{ py: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  textAlign: 'center',
                  borderRadius: 4,
                  backgroundColor: 'rgba(243, 232, 255, 0.6)',
                  border: '1px dashed #c4b5fd'
                }}
              >
                <CakeIcon sx={{ fontSize: 60, color: '#f759ab', mb: 2, opacity: 0.8 }} />
                <Typography variant="h5" sx={{ color: '#5b21b6', fontWeight: 600 }}>
                  No se encontró información del cumpleaños
                </Typography>
              </Paper>
            </Container>
          )
      }
    </Container>
  );
}

// Componente helper para mostrar elementos de información
function InfoItem({ icon, label, value, valueProps = {} }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box sx={{ mr: 1.5, mt: 0.3 }}>{icon}</Box>
      <Box>
        <Typography variant="caption" color="text.secondary" display="block">
          {label}
        </Typography>
        <Typography variant="body1" {...valueProps}>
          {value || 'No registrado'}
        </Typography>
      </Box>
    </Box>
  );
}

// Componente para tarjetas de información
function InfoCard({ title, icon, children }) {
  return (
    <Card
      elevation={2}
      sx={{
        borderRadius: 3,
        height: '100%',
        border: '1px solid rgba(124, 58, 237, 0.1)',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          boxShadow: '0 8px 25px rgba(124, 58, 237, 0.15)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          {icon}
          <Typography
            variant="h6"
            sx={{ ml: 1.5, color: '#5b21b6', fontWeight: 600 }}
          >
            {title}
          </Typography>
        </Box>
        <Divider sx={{ mb: 2 }} />
        {children}
      </CardContent>
    </Card>
  );
}

export default ViewBirthday;